import React, { FC } from 'react';

export const KarstDevelopment: FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    viewBox="0 0 1000 1000"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g
      id="Page-1"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
      fontFamily="Montserrat-Regular, Montserrat"
      fontSize={500}
      fontWeight="normal"
      letterSpacing={5}
    >
      <g id="Artboard" fill="currentColor">
        <text id="K">
          <tspan x="320.25" y={679}>
            K
          </tspan>
        </text>
        <text id="{" fill="currentColor">
          <tspan x={80} y={641}>
            {'{'}{' '}
          </tspan>
        </text>
        <text id="}" fill="currentColor">
          <tspan x={749} y={641}>
            {'}'}{' '}
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);
